module.exports = __webpack_public_path__ + "img/9788985635752.1c83d2ae.jpg";